import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "primevue/resources/primevue.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.min.css";
import "@/assets/main.css";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import PrimeVue from "primevue/config";
import TreeSelect from "primevue/treeselect";
import Dialog from "primevue/dialog";
import VueChartkick from "vue-chartkick";
import "chartkick/chart.js";
import "@fortawesome/fontawesome-free/css/all.css";
import JsonCSV from "vue-json-csv";
import ToastService from "primevue/toastservice";
import ConfirmationService from "primevue/confirmationservice";
import Tooltip from "primevue/tooltip";
import vuetify from "./plugins/vuetify";
import { createHead } from "@unhead/vue/client";

// @scalar/api-reference deep-clones loaded specs via structuredClone.
// Some inputs (Vue reactive proxy traps, YAML parser node wrappers)
// expose function-valued members that the native structuredClone refuses
// to clone. Wrap it so it falls back to a JSON-only clone (matching
// Scalar's own SSR fallback) only when the fast path throws.
if (typeof window !== "undefined" && typeof window.structuredClone === "function") {
  const nativeStructuredClone = window.structuredClone.bind(window);
  window.structuredClone = function safeStructuredClone(value, options) {
    try {
      return nativeStructuredClone(value, options);
    } catch (err) {
      return JSON.parse(
        JSON.stringify(value, (_k, v) =>
          typeof v === "function" ? undefined : v
        )
      );
    }
  };
}

const token = localStorage.getItem("token");

if (token) {
  store.commit("setLoggedIn", true);
}

const savedTheme = localStorage.getItem("theme") || "light";
if (savedTheme === "dark") {
  document.documentElement.classList.add("tw-dark");
  const themeLink = document.getElementById("theme-link");
  if (themeLink) themeLink.setAttribute("href", "/theme/dark/theme.css");
} else {
  document.documentElement.classList.remove("tw-dark");
}

const pinia = createPinia();
const app = createApp(App);
app.use(pinia);
app.use(vuetify);

// Required by @scalar/api-reference (uses useSeoMeta internally).
// Safe no-op for routes that don't touch document head.
app.use(createHead());
app.use(PrimeVue, { ripple: true }).use(ToastService).use(ConfirmationService);

app.component("DataTable", DataTable);
app.component("Column", Column);
app.component("TreeSelect", TreeSelect);
app.component("Dialog", Dialog);
app.component("downloadCsv", JsonCSV);
app.directive("tooltip", Tooltip);
app.use(VueChartkick);

app.use(store).use(router).mount("#app");
